










import { Vue, Component, Prop } from 'vue-property-decorator'
import { Target } from '@/store/freestyle'

@Component
export default class extends Vue {
  @Prop({
    type: String
  })
  src?: string

  @Prop({
    type: Object
  })
  target?: Target

  @Prop({
    type: String
  })
  css?: string

  get tag() {
    return this.src ? 'img' : 'div'
  }

  onClick() {
    const target = this.target
    if (!target) {
      return
    }
    switch (target.type) {
      case 'navigate':
        this.$emit('navigate', target.id, target.replace)
        break
      case 'router':
        this.$router.push({
          ...target.to,
          query: { ...this.$route.query, ...(target.to.query || {}) }
        })
        break
      case 'external':
        window.location.href = target.url + window.location.search
        break
      case 'event':
        this.$emit('click', target.name, target.args)
        break
    }
  }
}
